import useSWRImmutable from 'swr/immutable';
import capsFetcher from '../../shared/capsFetcher';

const fetcher = async (key) => {
  const res = await capsFetcher({
    url: key,
  });
  return res.data;
};

const useBankAccounts = (options) => useSWRImmutable(
  '/bank_accounts',
  fetcher,
  { suspense: true, ...options },
);

export default useBankAccounts;
